import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})

export class OtherChargesService {
    private baseURL: string;

    constructor(private http: HttpClient) {
        this.baseURL = environment.apiBaseUrl;
    }

    // Get all other charges
    getOtherCharges(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/OtherCharges/GetOtherCharges`,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    //Get all Revenue categories
    getAllRevenueCategories(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/RevenueCategory/GetAllRevenueCategories`,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    // Save or update an other charge
    saveOtherCharges(otherCharges: any): Observable<any> {
        return this.http.post<any>(
            `${this.baseURL}/OtherCharges/SaveOtherCharges`,
            otherCharges,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    // Delete an other charge
    deleteOtherCharge(otherChargeId: number): Observable<any> {
        return this.http.delete<any>(
            `${this.baseURL}/OtherCharges/DeleteOtherCharge/${otherChargeId}`,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    // Common error handler
    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            return throwError(() => error.error.message);
        }
        return throwError(() => error.message || 'Server error');
    }
}